import { render, staticRenderFns } from "./messengerIcon.vue?vue&type=template&id=44a6dbb7"
import script from "./messengerIcon.vue?vue&type=script&lang=js"
export * from "./messengerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports